import React from 'react';
import { makeClassName } from '@siteless/util';

const CheckCircleIcon = ({
  className,
  ...rest
}: {
  className?: string;
  [x: string]: any;
}) => (
  <svg
    className={makeClassName('CheckCircleIcon', className)}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    xmlSpace="preserve"
    {...rest}
  >
    <path
      d="M12,22.99C12,22.99,12,22.99,12,22.99c-6.07,0-11-4.94-11-11.01C1,5.93,5.94,0.99,12,0.99c0,0,0,0,0.01,0
	c1.55,0,3.06,0.32,4.47,0.95c0.5,0.22,0.73,0.82,0.51,1.32c-0.22,0.5-0.81,0.73-1.32,0.51C14.5,3.26,13.27,3,12.01,2.99c0,0,0,0,0,0
	c-4.96,0-9,4.03-9,9c0,4.96,4.03,9,8.99,9c0,0,0,0,0,0c4.96,0,9-4.03,9-8.99v-0.92c0-0.55,0.45-1,1-1s1,0.45,1,1V12
	C23,18.06,18.06,22.99,12,22.99z"
    />
    <path
      d="M12,15.01c-0.27,0-0.52-0.11-0.71-0.29l-3-3c-0.39-0.39-0.39-1.02,0-1.41s1.02-0.39,1.41,0L12,12.6l9.29-9.3
	c0.39-0.39,1.02-0.39,1.41,0c0.39,0.39,0.39,1.02,0,1.41l-10,10.01C12.52,14.9,12.27,15.01,12,15.01z"
    />
  </svg>
);

export default CheckCircleIcon;
